import Image from "next/image";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchGetAllNftPaginate } from "../../redux/apiSlice";
const Collection_dropdown2 = ({
  data,
  collection,
  priceRange,
  setPriceRange,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const [activeItem, setActiveItem] = useState({ id: 0, text: "All" });
  const router = useRouter();
  const dispatch = useDispatch();
  const { filterStatus } = useSelector((state) => state.api);
  const containerRef = useRef(null);
  const menuRef = useRef(null);
  const [isClient, setIsClient] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, minWidth: 180 });

  // Toggle dropdown open/close on trigger click
  const handleDropdown = () => setDropdown((prev) => !prev);

  // Close on outside click and Escape key
  useEffect(() => {
    setIsClient(true);
    const onClickOutside = (e) => {
      if (!containerRef.current) return;
      const clickedInsideTrigger = containerRef.current.contains(e.target);
      const clickedInsideMenu = menuRef.current?.contains(e.target);
      if (!clickedInsideTrigger && !clickedInsideMenu) {
        setDropdown(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setDropdown(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  // Position the menu using a fixed portal to avoid parent overflow clipping
  useEffect(() => {
    if (!dropdown || !isClient) return;
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const minWidth = Math.max(180, Math.floor(rect.width));
    let left = rect.left;
    const top = rect.bottom + 8; // small gap
    // First set optimistic position
    setMenuPos({ top, left, minWidth });
    // After next paint, clamp to viewport if overflowing
    requestAnimationFrame(() => {
      const menuEl = menuRef.current;
      if (!menuEl) return;
      const width = menuEl.getBoundingClientRect().width || minWidth;
      const overflowRight = left + width + 8 - window.innerWidth;
      if (overflowRight > 0) {
        left = Math.max(8, window.innerWidth - width - 8);
        setMenuPos({ top, left, minWidth });
      }
    });
  }, [dropdown, isClient]);
  const fetchData = () => {
    console.log(filterStatus);
    if (router.isReady) {
      const { campaignId } = router.query;
      if (campaignId === undefined) return null;
      try {
        dispatch(
          fetchGetAllNftPaginate({
            id: campaignId,
            offset: 0,
            isSold: filterStatus.isSold ?? false,
            All: filterStatus.All ?? false,
          }),
        );
      } catch (error) {
        console.error("API request failed:", error);
      }
    }
  };
  return (
    <>
      {/* Wrapper to anchor the dropdown correctly and handle outside clicks */}
      <div ref={containerRef} className="relative inline-block w-full">
        {collection ? (
          <div
            className="dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 flex items-center justify-between rounded-lg border bg-white py-3 px-4 z-10 transition-all hover:border-accent cursor-pointer"
            onClick={handleDropdown}
          >
            <span className="">{activeItem.text}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-jacarta-500 h-4 w-4 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
            </svg>
          </div>
        ) : (
          <div
            className="dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 flex items-center justify-between rounded-lg border bg-white py-3.5 px-3 text-base dark:text-white z-10"
            onClick={handleDropdown}
          >
            <span className="flex items-center">
              <Image
                width={20}
                height={20}
                src="/images/chains/ETH.png"
                alt="eth"
                className="mr-2 h-5 w-5 rounded-full"
              />
              Ethereum
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="fill-jacarta-500 h-4 w-4 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"></path>
            </svg>
          </div>
        )}

        {/* Dropdown menu via portal to escape overflow clipping */}
        {isClient && dropdown &&
          createPortal(
            <div
              ref={menuRef}
              style={{ position: "fixed", top: menuPos.top, left: menuPos.left, minWidth: menuPos.minWidth, zIndex: 9999 }}
              className="dark:bg-jacarta-800 w-max max-w-sm rounded-xl bg-white py-2 text-left shadow-xl border border-jacarta-100 dark:border-jacarta-600"
            >
              <ul className="scrollbar-custom max-h-60 overflow-y-auto py-1">
                {data.map((item) => {
                  const { id, text } = item;
                  return (
                    <li key={id}>
                      <button
                        className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-lg px-4 py-2 text-left text-sm transition-colors text-jacarta-700 dark:text-white"
                        onClick={() => {
                          setActiveItem({ id: id, text: text });
                          setPriceRange({ ...priceRange, status: text });
                          setDropdown(false);
                        }}
                      >
                        <span>{text}</span>
                        {activeItem.id === id && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            className="fill-accent mb-[1px] h-4 w-4"
                          >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                          </svg>
                        )}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>,
            document.body
          )}
      </div>
    </>
  );
};

export default Collection_dropdown2;
